// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._51f6d9{max-width:20em}.b4f26a{display:grid;gap:.5em;padding-right:.5em;margin:0 -1em 1em 0}", ""]);
// Exports
exports.locals = {
	"menu": "_51f6d9",
	"collaborators": "b4f26a"
};
module.exports = exports;
